import { render, staticRenderFns } from "./departuresCount.vue?vue&type=template&id=5ae0766d&"
import script from "./departuresCount.vue?vue&type=script&lang=js&"
export * from "./departuresCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports